import axios from 'axios'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { AppUserSchema, UserLogin } from '../models/app-user'

const login = async (credentials: UserLogin) => {
  const res = await axios.post('/api/login', credentials)
  return AppUserSchema.parse(res.data)
}

const logout = async () => {
  await axios.delete('/api/logout')
}

const getMe = async () => {
  const res = await axios.get('/api/me')
  return AppUserSchema.parse(res.data)
}

export const useLogin = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: login,
    onSuccess: (user) => {
      queryClient.setQueryData(['app-user'], user)
    },
  })
}

export const useLogout = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.setQueryData(['app-user'], null)
      queryClient.removeQueries({ queryKey: ['app-user'] })
    },
  })
}

export const useAppUser = () => {
  return useQuery({
    queryKey: ['app-user'],
    queryFn: getMe,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
